import React, { useEffect, useRef, useState } from "react";
import CreditTopup from "../subcription/CreditTopup";
import { useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";
// import { getDefaultNormalizer } from "@testing-library/react";
import { Credit_BALANCE, Recruiter_Profile_Status, RECURITER_CREDITHISTORY } from "../../Service/service";
import { getData } from "../../Service/ApiMethod";
import moment from "moment";
import '../home/component/ExtraPopup.css'
import { useTranslation } from "react-i18next";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { Modal, Button } from 'react-bootstrap';
import CheckoutForm from "../subcription/CheckoutForm";
import { lang } from "../../lang";

// import CheckoutForm from "./CheckoutForm";
const promise = loadStripe("pk_live_51NFrUvCibbZW6HqQh8TWqaUzdPwgmwoUv6noqe0ef1UbbCX0CPgfSUKkpTyawnNnGFNpvnyAeiS64GrZG1R4yfi000KUXj8uc8");


const CreditCoins = (props) => {
  const navigate = useNavigate();

  // const navigateToSuccess = (e) => {
  //   navigate("/credit");
  //   e.preventDefault();
  // };

  const { t } = useTranslation();
  const [ln,setLn] = useState('en')
  const [creditTopup, setCreditTopup] = useState(false);
  const [subcriptionDetail, setSubcriptionDetail] = useState(false);
  const [resdata, setResData] = useState();
  const [creditHistory, setCreditHistory] = useState([]);
  const [profileBeta, setProfileBeta] = useState()
  const [creditPopup, setCreditPopup] = useState(false)
  const [creditHistoryBackup, setCreditHistoryBackup] = useState([])
  const [showDetailPopup, setShowDetailPopup] = useState(false)
  const [showDetailPopupIndexing, setShowDetailPopupIndexing] = useState()
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const getDetail = () => {
    getData(Credit_BALANCE)
      .then((response) => response.json())
      .then((res) => {
        setResData(res.data.credit_balance_history[0])
      })
      .catch((err) => {
        console.log("Error ", err);
      });
  };
  console.log('resdata', resdata);
  const [pageNo, setPageno] = useState(1)
  const totalPage = useRef(1)
  const getCreditHistory = () => {
    getData(RECURITER_CREDITHISTORY+ "?pgNo=" + pageNo)
      .then((response) => response.json())
      .then((res) => {
        console.log(res.data,"creditHistory");
        setCreditHistory(res.data)
        setCreditHistoryBackup(res.data)
        totalPage.current = res.data.total_pages
      })
      .catch((err) => {
        console.log("Error ", err);
      });
  };
  console.log("sdfghj ", resdata);
  console.log('CreditHistory', creditHistory)

  const profile_Status = () => {
    getData(Recruiter_Profile_Status)
      .then((response) => response.json())
      .then((res) => {

        setProfileBeta(res.data)
        console.log("profile Data", res?.data);

      })
      .catch((err) => {
        console.log(err.message);
      });
  };


  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          props?.closeModalWrtOutsideClick();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const now = moment();
  const end = moment(resdata?.purchased_on).add(resdata?.validity, 'days');
  const daysLefts = end.diff(now, 'days');
  //  const dayLeft = ((daysLefts<=0) ? 0 : daysLefts)
  console.log('daysLeft', daysLefts)


  const handleCreditHistoryFilter = (keyword) => {
    let temp = [...creditHistoryBackup];
    if (keyword == 'All') {
      console.log('newData', temp)
      setCreditHistory(temp)
    }
    else if (keyword == 'Premium') {
      const newData = temp?.filter((item) => item?.seeker_user?.is_premium == true)

      console.log('newData', newData)
      setCreditHistory(newData)
    } else {
      const newData = temp?.filter((item) => item?.seeker_user?.is_premium == false)

      console.log('newData', newData)
      setCreditHistory(newData)
    }
  }


  // const sortedData = creditHistory?.sort((a, b) => {
  //   const dateA = moment(a?.created_at);
  //   const dateB = moment(b?.created_at);
  //   if (dateA.isBefore(dateB)) {
  //     return 1; // swap the two items in the array
  //   }
  //   if (dateA.isAfter(dateB)) {
  //     return -1; // do not swap the two items in the array
  //   }
  //   return 0; // do not change the order of the two items in the array
  // });





  // function dateToFromNowDaily(myDate) {

  //   var fromNow = moment(myDate).format('ddd');

  //   return moment(myDate).calendar(null, {

  //     lastDay: '[Yesterday]',
  //     sameDay: '[Today]',

  //     // when the date is further away, use from-now functionality             
  //     sameElse: function () {
  //       return "[" + fromNow + "]";
  //     }
  //   });
  //   }



  function dateToFromNowDaily(myDate) {
    const today = moment().startOf('day');
    const myDateStartOfDay = moment(myDate).startOf('day');
    const diffDays = today.diff(myDateStartOfDay, 'days');

    if (diffDays === 0) {
      // Today
      return <span>{t('Today')}</span>;
    } else if (diffDays === 1) {
      // Yesterday
      return <span>{t('Yesterday')}</span>;
      // } else if (diffDays >= 2 && diffDays <= 6) {
      //   // Last 7 days
      //   const dayOfWeek = moment(myDate).format('dddd');
      //   return <span>{dayOfWeek}</span>;
    } else if (diffDays >= 7) {
      // More than 7 days ago
      const monthName = moment(myDate).format('MMMM');
      const dayOfMonth = moment(myDate).format('D');
      const year = moment(myDate).format('YYYY');
      return (
        <span>
          {dayOfMonth} {monthName} {year}
        </span>
      );
    } else if (diffDays >= 2 && diffDays <= 6) {

      const dayOfWeek = moment(myDate).format('dddd')
      const time = moment(myDate).format('hh:mm a');

      return (
        <span>{t('Last')} {dayOfWeek} {t('at')} {time} </span>
      )

    }
    else {
      // Unknown date
      return <span>{t('Unknown')}</span>;
    }
  }

  const [issueApply, setIssueapply] = useState(false)
  const [client_scrate, setScrate] = useState('')

  useEffect(() => {
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
    getDetail();
    getCreditHistory();
    profile_Status()
  }, []);

  return (
    <div className="credit-coins-container" ref={wrapperRef}>
      <div className="credit-coins">
        <div className="space-between d-flex mb-2">
          <h2 className="popup-heading">
            {t('Credit balance')}
            <img src="./images/credit-coins.png" className="ml-2 credit-iconn" alt="" />
          </h2>
          <button className="view-all btn-none" onClick={props?.crossClose}>
            {lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth['Close']:""}
          </button>
        </div>

        <>
          <div >
            <div className="space-between d-flex">
              <p className="text">{t('Available Credits')}</p>
              <p style={{ color: 'black' }} className="text text-bold">{resdata?.available_credits}</p>
            </div>
            <div className="space-between d-flex mb-2">
              <p className="text">{t('Used Credits')}</p>
              <p className="text text-bold">{resdata?.coalesce}</p>
            </div>
            <hr className="line m-0 mb-2" />

            <div
              className="space-between d-flex pb-2"
              style={{ borderBottom: "1px dashed grey" }}
            >
              <p className="text">{t('Total Credits')}</p>
              <p className="text text-bold">{resdata?.total_credits}</p>
            </div>
          </div>

          <div className="subcription-details">
            <h2 className="popup-heading my-2">{t('Subscription Details')}</h2>

            <div className="space-between d-flex " style={{}}>
              <div className="div mb-2">
                <h2 className="text">
                  {lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation[resdata?.plan_name]:""}
                  <button
                    className="btn-none"
                    onClick={() => {
                      setSubcriptionDetail(!subcriptionDetail);
                    }}
                  >
                    <img
                      src="./images/toggle-down.png"
                      className="ml-2"
                      alt=""
                    />
                  </button>
                </h2>
              </div>
              <div className="days-left">{isNaN(daysLefts) ? 0 : daysLefts} {t('Days left')}</div>
            </div>

            {subcriptionDetail ? (
              <> 
                <div className="my-3">
                  <div className="space-between d-flex " style={{}}>
                    <div className="div mb-2">
                      <h2 className="text">{t('Purchased Date')}</h2>
                    </div>
                    <div className="text text-right text-black-50">
                      {/* {moment(resdata?.purchased_on).format("D MMM YYYY")} */}
                      {(resdata?.purchased_on) == "NA" ? "NA" : moment(resdata?.purchased_on).format("D MMM YYYY")}

                    </div>
                  </div>
                  <div className="space-between d-flex " style={{}}>
                    <div className="div mb-2">
                      <h2 className="text">{t('Validity')}</h2>
                    </div>
                    <div className="text text-right text-black-50">
                      {resdata?.validity} {t('days')}
                    </div>
                  </div>
                  <div className="space-between d-flex " style={{}}>
                    <div className="div mb-2">
                      <h2 className="text">{t('Amount')}</h2>
                    </div>
                    <div className="text text-right text-black-50" style={{ fontWeight: '', color: 'black' }}>
                    € {resdata?.subscription_amount}
                    </div>
                  </div>
                  <div className="space-between d-flex " style={{}}>
                    <div className="div mb-2">
                      {/* <h2 className="text">{t('Payment Mode')}</h2> */}
                    </div>
                    <div className="text text-right text-black-50">
                      {resdata?.payment_mode}
                    </div>
                  </div>
                </div>
              </>
            ) : null}

            {/* <p>{item.available_credits}</p> */}
          </div>
        </>
        <p className="text" style={{ fontSize: "10px", marginTop: "-7px" }}>
          ({resdata?.validity} {lang && Object.keys(lang).length > 0 ? lang[ln]?.CreditHistory['days Validity']:''})
        </p>

        {!(profileBeta?.user?.user_types == 'sub_user') &&
          <>
            <div
              className="d-flex justify-content-around my-3 pb-3"
              style={{ borderBottom: "1px dashed grey" }}
            >
              <div
                // to="/subcription"
                onClick={() => {
                  props?.upgrade()
                  navigate('/subcription')
                }}
                className="theme-btn-outline m-0 me-2"
                style={{ padding: '6px 24px' }}

              >
                {lang && Object.keys(lang).length > 0 ? lang[ln]?.CreditHistory['Upgrade Plan']:""}
              </div>
              <button
                className="theme-btn ms-2 "
                onClick={() => {
                  // setCreditTopup(!creditTopup);
                  navigate("/search-list")
                }}
              >
                {lang && Object.keys(lang).length > 0 ? lang[ln]?.CreditHistory['Credit Top-up']:""}
              </button>
            </div>
          </>
        }

        {creditTopup ? (
          <CreditTopup
            subcriptionDetail={resdata}
            closePopup={(e) => {
              setCreditTopup(!creditTopup);
              setIssueapply(true)
              let local = localStorage.getItem("client_scrate")
              setScrate(local)
              // navigate("/search-list");
            }}
            closeModalWrtOutsideClick={() => {
              setCreditTopup(!creditTopup);
            }}
          />
        ) : null}

        <Modal className="cardDetailModal"  show={issueApply} style={{ }}>
          <Modal.Header>
            <h5>Enter Card Details</h5>
          </Modal.Header>
          <Modal.Body>
            <div className="App">
              <Elements stripe={promise}>
                <CheckoutForm clientSecretss={client_scrate} checkVal={() => { setIssueapply(false) }} />
              </Elements>
            </div>
          </Modal.Body>
        </Modal>















        {/* <hr className="line m-0" /> */}
 
        <div className="space-between d-flex my-3 horizontal-center">
          <p className="text text-bold">{t('Credit History')}</p>
          {/* <img style={{}} src="./images/filter-icon.png" className="filterr" alt="" onClick={() => setCreditPopup(!creditPopup)} /> */}
        </div>
        {creditPopup &&
          <div style={{
            height: "130px", width: "300px", border: "1px solid rgb(106, 103, 103)"
            , display: "flex", flexDirection: "column", borderRadius: "10px", marginLeft: '10px'
          }}>
            <span className="hover-popup" style={{ color: 'black' }} onClick={(e) => {
              // e.stopPropagation()
              handleCreditHistoryFilter('All')
              setCreditPopup(!creditPopup)
            }}>{t('All')}</span>
            <hr />
            <span className="hover-popup" style={{ color: 'black' }} onClick={(e) => {
              // e.stopPropagation()
              handleCreditHistoryFilter('Premium')
              setCreditPopup(!creditPopup)
            }}>{t('Premium')}</span>
            <hr />
            <span className="hover-popup" style={{ color: 'black' }} onClick={(e) => {
              // e.stopPropagation()
              handleCreditHistoryFilter('Not Premium')
              setCreditPopup(!creditPopup)
            }}>{t('Not Premium')}</span>
            <hr />
          </div>
        }

        {creditHistory.credit_history?.length > 0 ? creditHistory.credit_history?.map((saurabh, i) => {
          return (
            <div key={i}>
            
              {/* <p className="credit-date my-2">Today</p> */}
              <p style={{ color: 'black', marginTop: '5px' }}>
                {dateToFromNowDaily(saurabh?.created_at)}
                {/* {moment(saurabh?.created_at).format('dddd')} at {moment(saurabh?.created_at).format('HH:mm A')} */}
              </p>
              <div className="row msg-notification horizontal-center p-2" onClick={(e) => {
                // e.stopPropagation()
                setShowDetailPopup(!showDetailPopup)
                setShowDetailPopupIndexing(i)
              }} style={{ position: 'relative' }}>
                <div className="col-2 px-0">
                  <img style={{ width: '40px', height: '40px', borderRadius: '80%', marginLeft: "5px" }} src={saurabh?.credit_type == 2 ? saurabh?.seeker_user?.seeker_image || "../images/Vector.png":saurabh?.vacancy_details?.vacancy_image || "../images/Vector.png"} className="mr-0" alt="" />
                  <div style={{ position: "relative", marginTop: "-7px" }}>
                    {saurabh?.seeker_user?.is_premium && <div

                      className="premium-text">
                      {t('Premium')}
                    </div>
                    }

                  </div>
                </div>
                <div className="col-7 pr-0">
                  <div className="div">
                    <p className="text">{saurabh?.credit_type == 2 ? saurabh?.seeker_user?.first_name:saurabh?.vacancy_details?.vacancy_title} {saurabh?.credit_type == 2 ?saurabh?.seeker_user?.last_name:null}</p>
                    <p className="profile">{saurabh?.credit_type == 2 ? saurabh?.seeker_user?.job_category_name:null}</p>
                  </div>

                  {/* <button className="view-notification">View Message</button> */}
                </div>
                <div
                  className="col-3 px-0"
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    alignItems: "end",
                  }}
                >
                  <p className=" horizontal-center" style={{  marginBottom: 21}}>
                    <p className="text">
                      -{saurabh?.used_credits}{" "}
                      <img className="credit-iconn ml-1" src="./images/credit-coins.png "  alt="" />
                    </p>
                    <img
                      src="./images/go-arrow.png"
                      className="ms-4 h-100 ml-4"
                      alt=""
                    />
                  </p>
                </div>
              </div>
              <hr className="line m-0" />
              {creditHistory.credit_history && showDetailPopupIndexing == i &&
                <div style={{ height: "85px", width: "300px", color: 'grey', padding: '7px', borderRadius: "10px", border: "1px solid rgb(106, 103, 103)", position: 'sticky', top: '50%', background: 'white' }}>
                  <div style={{ marginTop: "2px" }}>{t('Unlocked By')}</div>
                  <div>
                    <img style={{ height: "50px", width: "50px", float: "left", marginLeft: "8px", marginTop: "5px", borderRadius: "50%" }}
                      src={saurabh?.unlocked_by?.profile_pic} alt="" />
                    <div style={{ float: "left", marginTop: "10px", marginLeft: "6px" }}>
                      <p style={{ marginBottom: '10px', fontSize: '15px' }}>{saurabh?.unlocked_by?.first_name}</p>
                      <p>{t('User Type')} :  {saurabh?.unlocked_by?.user_type}</p>
                    </div>
                  </div>

                </div>
              }
            </div>
          )
        }) : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '20px', color: 'grey', marginTop: '30px' }}>{t('No Data Found')}</div>}


<div style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        justifyContent: "center",
        marginBottom: 10
      }}>
        <div>
          <p style={{ marginBottom: 0, paddingRight: 5, cursor: "pointer",color:"#000" }} onClick={() => {
            if (pageNo > 1) {

              setPageno(pageNo - 1)
              console.log("yo");
              // newNoti.current = []
              setTimeout(()=>{
                getCreditHistory()
              },1000)
             
            } else {
              console.log("no more data found");
            }
          }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["previous"]:""}</p> 
        </div>
        <input placeholder='Pg. no.' type="text"
          disabled={true}
          style={{
            textAlign: "center",
            width: 60,
            padding: 10,
            borderColor: "#f2edf3",
            backgroundColor: "#f2edf3",
            borderRadius: 10,
            borderWidth: 0
          }} value={pageNo + "/" + totalPage.current} />
        <div>
          <p style={{ marginBottom: 0, paddingLeft: 5, cursor: "pointer",color:"#000" }} onClick={() => {
            if (pageNo < totalPage.current) {
              setPageno(pageNo + 1)
              console.log("yono");
              // newNoti.current = []
              setTimeout(()=>{
                getCreditHistory()
              },1000)
            } else {
              console.log("no more data found");
            }
          }}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Next"]:""}</p>
        </div>
      </div>
        
      </div>
    </div>
  );
};

export default CreditCoins;
